import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { 
  FaWater, 
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaHeart
} from 'react-icons/fa';
import NewsletterSignup from '../NewsletterSignup';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <Container>
          {/* Newsletter Section */}
          <Row className="mb-5">
            <Col lg={8} className="mx-auto">
              <div className="footer-newsletter">
                <NewsletterSignup inline={true} />
              </div>
            </Col>
          </Row>

          <Row className="g-4">
            {/* Brand & About */}
            <Col lg={4} md={6}>
              <div className="footer-brand">
                <div className="brand-logo">
                  <FaWater />
                  <h3>DiveConnect</h3>
                </div>
                <p className="brand-description">
                  Discover your next underwater adventure. We connect passionate divers 
                  with unforgettable scuba diving experiences worldwide.
                </p>
                <div className="social-links">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <FaFacebook />
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <FaTwitter />
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <FaInstagram />
                  </a>
                  <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                    <FaYoutube />
                  </a>
                </div>
              </div>
            </Col>

            {/* Quick Links */}
            <Col lg={2} md={6}>
              <div className="footer-section">
                <h4 className="footer-title">Explore</h4>
                <ul className="footer-links">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/trips">All Trips</Link></li>
                  <li><Link to="/blog">Blog</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                </ul>
              </div>
            </Col>

            {/* Support */}
            <Col lg={2} md={6}>
              <div className="footer-section">
                <h4 className="footer-title">Support</h4>
                <ul className="footer-links">
                  <li><Link to="/faq">FAQ</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                  <li><Link to="/privacy">Privacy Policy</Link></li>
                  <li><Link to="/terms">Terms of Service</Link></li>
                </ul>
              </div>
            </Col>

            {/* Contact Info */}
            <Col lg={4} md={6}>
              <div className="footer-section">
                <h4 className="footer-title">Get in Touch</h4>
                <ul className="footer-contact">
                  <li>
                    <FaEnvelope />
                    <a href="mailto:info@dive-connect.com">info@dive-connect.com</a>
                  </li>
                  <li>
                    <FaPhone />
                    <a href="tel:+491354538502">+49 1354 538502</a>
                  </li>
                  <li>
                    <FaMapMarkerAlt />
                    <span>123 Ocean Drive, Dive City, DC 12345</span>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start">
              <p className="copyright">
                © {currentYear} DiveConnect. All rights reserved.
              </p>
            </Col>
            <Col md={6} className="text-center text-md-end">
              <p className="made-with">
                Made with <FaHeart className="heart-icon" /> for divers worldwide
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
